const useCurrentUser = (userId, listId) => {
    if (!userId || !listId || userId === null) return false;

    return listId.includes(userId);

}

export default useCurrentUser;